import { render, staticRenderFns } from "./MessengerSearch.vue?vue&type=template&id=247f4b41&scoped=true&"
import script from "./MessengerSearch.vue?vue&type=script&lang=js&"
export * from "./MessengerSearch.vue?vue&type=script&lang=js&"
import style0 from "./MessengerSearch.vue?vue&type=style&index=0&id=247f4b41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247f4b41",
  null
  
)

export default component.exports